import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'masterflex',
} as IModuleProps;
